module.exports = __webpack_public_path__ + "img/photo-hobbie-cooking.257e88d9.jpg";